import fixIOSAudioApiPlayback from './fixIOSAudioApiPlayback';
import { ensureSafariAudioSession } from './ensureSafariAudioSession';

export function isSafari() {
  return (
    typeof window !== 'undefined' && /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  );
}

export { fixIOSAudioApiPlayback, ensureSafariAudioSession };
